<template>
	<div class="gallery-container flex-col-ac-js" ref="galleryContainer">
		<div class="list-grid flex-row-as-jc">
			<ArticleCard v-for="(article, index) in articleList" :key="article.articleId" :article="article"
				:aspect-ratio="0.885" @collectArticle="collectArticle" v-animate-item />
		</div>

		<div class="no-data" v-if="articleList.length === 0">
			暂无数据
		</div>

		<!-- 上滚加载提示 -->
		<div class="loading-more" v-if="loading && articleList.length > 0">
			<div class="loading-spinner"></div>
			<span>正在加载更多...</span>
		</div>

		<div class="no-more-data" v-if="!loading && articleList.length > 0 && currentPage >= totalPages">
			没有更多数据了
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import ArticleCard from '@/components/card.vue'

	export default {
		name: 'GalleryList',
		components: {
			ArticleCard
		},
		data() {
			return {
				articleList: [],
				currentPage: 1,
				pageSize: 12,
				total: 0,
				phone: '',
				loading: false, // 加载状态
				isLoadingMore: false, // 是否正在加载更多数据
				scrollPosition: 0
			}
		},
		computed: {
			...mapState(['isLogin', 'userInfo']),
			totalPages() {
				return Math.ceil(this.total / this.pageSize)
			}
		},
		directives: {
			'animate-item': {
				inserted(el) {
					el.style.opacity = '0';
					el.style.transform = 'translateY(20px)';
					el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
					setTimeout(() => {
						el.style.opacity = '1';
						el.style.transform = 'translateY(0)';
					}, 100);
				}
			}
		},
		created() {
			this.phone = localStorage.getItem('phone') || ''
			this.fetchArticleList()
		},
		mounted() {
			// 添加滚动事件监听
			const webContainer = document.querySelector('.web-container');
			if (webContainer) {
				webContainer.addEventListener('scroll', this.handleScroll);
			}
		},
		unmounted() {
			// 移除滚动事件监听
			const webContainer = document.querySelector('.web-container');
			if (webContainer) {
				webContainer.removeEventListener('scroll', this.handleScroll);
			}
		},
		methods: {
			switchTab(tab) {
				this.activeTab = tab
				this.currentPage = 1
				this.fetchArticleList()
			},

			// 处理滚动事件
			handleScroll() {
				const webContainer = document.querySelector('.web-container');
				if (!webContainer || this.loading || this.currentPage >= this.totalPages) {
					return;
				}

				// 当滚动到距离底部200px时，加载下一页
				const scrollHeight = webContainer.scrollHeight;
				const scrollTop = webContainer.scrollTop;
				const clientHeight = webContainer.clientHeight;

				if (scrollTop + clientHeight >= scrollHeight - 200) {
					this.loadMore();
				}
			},

			// 加载下一页数据
			loadMore() {
				if (this.isLoadingMore) return;
				this.isLoadingMore = true;

				// 使用setTimeout模拟网络延迟，让用户可以看到加载动画
				setTimeout(() => {
					this.currentPage++;
					this.fetchArticleList(true);
				}, 300);
			},

			fetchArticleList(isLoadMore = false) {
				this.loading = true;
				let params = {
					pageNo: this.currentPage,
					pageSize: this.pageSize,
				};
				console.log(`--api.getArticlePage参数`);
				console.log(params);
				this.$http.getArticlePage(params).then((res) => {
					console.log(`--api.getArticlePage结果`);
					console.log(res)
					if (res.code != 0) {
						this.$message.error(res.message || '获取数据失败')
						if (isLoadMore) {
							this.currentPage--;
						}
					} else {
						if (isLoadMore) {
							// 上滚加载时，将新数据追加到现有列表
							this.articleList = [...this.articleList, ...(res.data.rows || [])];
						} else {
							// 首次加载或切换页时，替换现有列表
							this.articleList = res.data.rows || [];
						}
						this.total = res.data.total || 0;
					}
				}).finally(() => {
					this.loading = false;
					this.isLoadingMore = false;
				});
			}

		}
	}
</script>

<style scoped lang="scss">
	.gallery-container {
		width: 100%;
		padding: 40px 16.7vw 50px;
		background-color: #F8F8F8;
		box-sizing: border-box;
	}

	.list-grid {
		min-height: calc(100vh - 50px);
		display: grid;
		/* 默认最少2列，使用 min() 函数确保列宽不小于440px */
		grid-template-columns: repeat(2, minmax(440px, 1fr));
		gap: 24px;
		margin-bottom: 30px;
		justify-items: center;
	}

	/* 中等屏幕：3列布局 */
	@media (min-width: 1280px) {
		.list-grid {
			grid-template-columns: repeat(2, minmax(440px, 1fr));
		}
	}

	/* 大屏幕：4列布局 */
	@media (min-width: 1920px) {
		.list-grid {
			grid-template-columns: repeat(3, minmax(440px, 1fr));
		}
	}

	.no-data {
		text-align: center;
		padding: 60px 0;
		color: #999;
		font-size: 18px;
	}

	/* 上滚加载样式 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 40px 0;
		color: #606266;
		font-size: 14px;
		gap: 10px;
	}

	/* 加载动画 */
	.loading-spinner {
		width: 20px;
		height: 20px;
		border: 2px solid #f3f3f3;
		border-top: 2px solid #409eff;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	/* 没有更多数据提示 */
	.no-more-data {
		text-align: center;
		padding: 30px 0;
		color: #999;
		font-size: 14px;
	}

	/* 为列表项添加进入动画延迟，使动画更自然 */
	.list-grid>div {
		animation-delay: calc(var(--v-enter-index) * 50ms);
	}
</style>